import { cn } from '../../app/utils/cn'

type SegmentedOption<T extends string> = {
  label: string
  value: T
}

interface SegmentedControlProps<T extends string> {
  options: SegmentedOption<T>[]
  value: T
  onChange: (value: T) => void
  className?: string
}

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  className,
}: SegmentedControlProps<T>) {
  return (
    <div
      className={cn(
        'flex w-full gap-2 rounded-full bg-[#F8F8F8] p-2',
        className,
      )}
    >
      {options.map((option) => {
        const isActive = option.value === value

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'flex h-12 flex-1 items-center justify-center gap-2 rounded-full px-4 transition-all',
              isActive ? 'bg-white text-black shadow-md' : 'text-gray-300',
            )}
          >
            <span
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full border-2',
                isActive ? 'border-primary' : 'border-gray-200',
              )}
            >
              <span
                className={cn(
                  'h-2.5 w-2.5 rounded-full',
                  isActive ? 'bg-primary' : 'bg-gray03',
                )}
              />
            </span>

            <span className="text-sm font-semibold">{option.label}</span>
          </button>
        )
      })}
    </div>
  )
}
